module.exports = __webpack_public_path__ + "img/reduction-pie-charts.0cacf575.png";